import React from "react";

const Button = ({
  title = "",
  url = "",
  target = "_self",
  className = "mx-auto mb-6",
  background = "secondary",
  hoverBackground = "primary",
  color = "white",
  children = null,
  size = "lg",
}) => {
  if (!title) return null;

  const sizeMapClass = {
    sm: "px-8 py-2 text-[12px]",
    md: "px-10 py-2 text-[14px]",
    lg: "px-12 py-2 text-[16px]",
  };

  const sizeClass = sizeMapClass[size];

  return (
    <a
      href={url}
      target={target}
      className={`${sizeClass} rounded-xl font-openSans bg-${background} text-${color} transition-all duration-500 hover:bg-${hoverBackground} ${className}`}
    >
      {children || title}
    </a>
  );
};

export default Button;
